import React from 'react';
import { find } from 'lodash';

import { Profile, SelectMenu } from 'components';

import styles from './Members.module.scss';

interface EntryProps {
  actions?: any;
  user: any;
  onAction?: any;
}

export const MemberEntry: React.FC<EntryProps> = ({ actions, user, onAction }) => {
  const { id, name, email, avatarUrl } = user;
  const selected = actions && find(actions, { selected: true });

  return (
    <div className={styles.member}>
      <Profile
        className={styles.profile}
        profile={{
          id: id,
          displayName: name,
          emailAddress: email,
          photoURL: avatarUrl,
        }}
      />

      {actions && onAction && (
        <SelectMenu
          buttonClassName={styles.memberDropdownTrigger}
          arrow
          closeOnClick
          horizontalPosition="Right"
          id={`select-${id}`}
          menuClassName={styles.menu}
          onChange={(option, event) => onAction(option, user, event)}
          options={actions}
          value={selected.key}
        />
      )}
    </div>
  );
};
